import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import OptionValueCalculator from './OptionValueCalculator';

const OptionValueInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Option Value Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Option Value Calculator helps options traders determine the theoretical value of options contracts. It uses the Black-Scholes model to calculate option premiums, helping you make informed trading decisions and manage your options portfolio effectively.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Underlying Asset Price</li>
        <li>Strike Price</li>
        <li>Time to Expiration</li>
        <li>Volatility</li>
        <li>Risk-Free Rate</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses the Black-Scholes model to determine option values:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Call Option Value = S × N(d1) - X × e^(-rT) × N(d2)</li>
        <li>Put Option Value = X × e^(-rT) × N(-d2) - S × N(-d1)</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculate theoretical option prices</li>
        <li>Assess option pricing factors</li>
        <li>Manage options risk</li>
        <li>Plan trading strategies</li>
        <li>Make informed options decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter the underlying asset price, strike price, time to expiration, volatility, and risk-free rate to calculate the theoretical value of options contracts. The calculator will provide insights into option pricing and help you make informed trading decisions.</p>
    </div>
  );
};

const OptionValue = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <OptionValueCalculator/>
        </div>
        <OptionValueInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default OptionValue;